import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { AddIcon, CloseIcon } from 'Components/Shared/Icon'
import { Picker } from 'Components/Shared/Form'
import Editor from 'Components/Pages/ActivityDetailPage/Editor'
import file from '../../utils/file'
import { LIMIT_FILE } from '../../config'
import imgPhoto from 'assets/img/ic-photo.png'
import imgAddIcon from 'assets/img/ic_add_blue.png'
import Col from 'antd/lib/grid/col'
import { Modal, Row } from 'antd'
import PrimaryButton from 'Components/Shared/Button/PrimaryButton'
import { OutlineButton } from 'Components/Shared/Button'

type Props = {
  onChange: (images: any) => void
  Image: any
  title?: string
  viewMode?: boolean
  onThumbnailOpen?: (image: any) => void
  IsFixImageLost?: boolean
  onConfirmUploadFixImage?: (confirm: any) => void
}

const SingleImgPicker: React.FunctionComponent<Props> = props => {
  const {
    onChange,
    Image,
    title = '',
    viewMode = false,
    onThumbnailOpen,
    IsFixImageLost = false,
    onConfirmUploadFixImage,
  } = props
  const [showEditor, setShowEditor] = useState(false)
  const [fileEditor, setFileEditor] = useState({
    base64: '',
    file: { name: '' },
    lastModified: 0,
  })

  const [visibleConfirm, setVisibleConfirm] = useState(false)
  const [resetImage, setResetImage] = useState(Image)
  const [showFixImageEditor, setShowFixImageEditor] = useState(false)
  const [fileFixImageEditor, setFileFixImageEditor] = useState({
    base64: '',
    file: { name: '' },
    lastModified: 0,
  })
  const [isFixImage, setIsFixImage] = useState(false)
  useEffect(() => {
    if (IsFixImageLost == true) {
      setIsFixImage(true)
    }
  }, [IsFixImageLost])
  const addFile = async (base64: any, fileItem: any) => {
    try {
      const lastModified = fileItem.lastModified
      let resp
      if (fileItem.type === 'image/heic') {
        resp = await file.heicToJpeg({
          file: fileItem,
          filename: fileItem.name,
        })
        base64 = resp.text
        fileItem = resp.file
      }
      if (fileItem.size < LIMIT_FILE.image) {
        resp = await file.compress({
          value: base64,
          file: fileItem,
          limit: LIMIT_FILE.image,
        })
        base64 = resp.text
        fileItem = resp.file
      }
      setShowEditor(true)
      setFileEditor({ base64, file: fileItem, lastModified })
    } catch (e) {}
  }

  const fixFile = async (base64: any, fileItem: any) => {
    try {
      const lastModified = fileItem.lastModified
      let resp
      if (fileItem.type === 'image/heic') {
        resp = await file.heicToJpeg({
          file: fileItem,
          filename: fileItem.name,
        })
        base64 = resp.text
        fileItem = resp.file
      }
      if (fileItem.size < LIMIT_FILE.image) {
        resp = await file.compress({
          value: base64,
          file: fileItem,
          limit: LIMIT_FILE.image,
        })
        base64 = resp.text
        fileItem = resp.file
      }
      setResetImage(Image)
      setShowFixImageEditor(true)
      setFileFixImageEditor({ base64, file: fileItem, lastModified })
    } catch (e) {}
  }

  const onAddImage = async (base64: string) => {
    try {
      const params = {
        data: base64,
        filename: fileEditor.file.name,
        lastModified: fileEditor.lastModified,
      }
      const fileItem: any = await file.base64ToFile(params)
      const newImage = {
        text: base64,
        file: fileItem,
        lastModified: fileItem.lastModified,
      }
      onChange(newImage)
      setFileEditor({
        base64: '',
        file: { name: '' },
        lastModified: 0,
      })
    } catch (e) {}
    setShowEditor(false)
  }

  const onFixImage = async (base64: string) => {
    try {
      const params = {
        data: base64,
        filename: fileFixImageEditor.file.name,
        lastModified: fileFixImageEditor.lastModified,
      }
      const fileItem: any = await file.base64ToFile(params)
      const newImage = {
        text: base64,
        file: fileItem,
        lastModified: fileItem.lastModified,
      }
      onChange(newImage)
      setFileFixImageEditor({
        base64: '',
        file: { name: '' },
        lastModified: 0,
      })
      setVisibleConfirm(true)
    } catch (e) {}
    setShowFixImageEditor(false)
  }

  const onConfirmUpdateFixImage = () => {
    setVisibleConfirm(false)
    onConfirmUploadFixImage && onConfirmUploadFixImage(true)
  }

  const addImage = (
    <Picker
      name={title}
      loading={false}
      disabled={false}
      text={'ADA'}
      accept=".png,.jpg,.heic"
      onChange={addFile}
      customPickerBtn={
        <AddImage>
          <AddIcon size={32} color="#8b99a7" />
          <div>คลิกเพื่อเพิ่มรูปภาพ</div>
        </AddImage>
      }
    />
  )

  const fixImage = (
    <div>
      <Picker
        name={title}
        loading={false}
        text={'ADA'}
        accept=".png,.jpg,.heic"
        onChange={fixFile}
        customPickerBtn={
          <AddImage>
            <img src={imgAddIcon} alt="" width={20} height={20} />
          </AddImage>
        }
      />
    </div>
  )

  const onResetImage = () => {
    setVisibleConfirm(false)
    onChange(resetImage)
  }

  const noneImage = (
    <ActionImage>
      <img src={imgPhoto} alt="" />
      <div>ไม่มีรูปภาพ</div>
    </ActionImage>
  )

  const emptyImage = !Image
  const imgContent = !emptyImage
    ? Image.FileID
      ? Image.FileURL
      : Image.text
    : ''

  const buttonAction = (
    <Row>
      <Col span={6} offset={6}>
        <OutlineButton
          text="ยกเลิก"
          disabled={false}
          onClick={() => onResetImage()}
        />
      </Col>
      <Col span={11} offset={1}>
        <PrimaryButton text="ยืนยัน" onClick={onConfirmUpdateFixImage} />
      </Col>
    </Row>
  )
  return (
    <>
      <Editor
        visible={showEditor}
        image={fileEditor.base64}
        onClose={() => setShowEditor(false)}
        onOk={onAddImage}
      />

      <Editor
        visible={showFixImageEditor}
        image={fileFixImageEditor.base64}
        onClose={() => setShowFixImageEditor(false)}
        onOk={onFixImage}
      />

      <Modal
        centered
        visible={visibleConfirm}
        width="528px"
        footer={null}
        closeIcon={<CloseIcon color="#8b99a7" size={16} />}
        title={<Header>บันทึกรูป</Header>}
        className="add-checklist-modal"
        onCancel={() => setVisibleConfirm(false)}
      >
        <ModalContent>
          <span>ยืนยันต้องการบันทึกรูป</span>&nbsp;&nbsp;
          <ButtonSection>{buttonAction}</ButtonSection>
        </ModalContent>
      </Modal>

      <Box>
        <Header>
          <Row type="flex" justify="start">
            <Col>
              {title}
              &nbsp; &nbsp; &nbsp;
            </Col>

            {isFixImage && <Col>{fixImage}</Col>}
          </Row>
        </Header>

        <ImageBox
          style={{ backgroundImage: `url(${imgContent})` }}
          onClick={() => onThumbnailOpen && onThumbnailOpen(Image)}
        >
          {emptyImage && (viewMode ? noneImage : addImage)}
        </ImageBox>
      </Box>
    </>
  )
}

const Box = styled.div`
  padding: 15px;
  width: 100%;
`
const ImageBox = styled.div`
  margin-top: 10px;
  padding: 8px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #b9c6d3;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Header = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 20px;
`
const ActionImage: any = styled.div`
  font-family: 'DB Helvethaica X 55 Regular';
  color: #8b99a7;
  text-align: center;
  font-size: 20px;
  img {
    width: 28px;
    height: 27px;
    object-fit: contain;
    border: 0px;
    min-height: 27px;
    margin-bottom: 12px;
  }
`
const AddImage = styled(ActionImage)`
  cursor: pointer;
`
const ModalContent = styled.div`
  padding: 0 24px 31px 24px;
  font-family: 'DB Helvethaica X 55 Regular';
  font-size: 20px;
`
const ButtonSection = styled.div`
  margin-top: 32px;
  .btn-submit {
    width: 160px;
    margin-left: 16px;
  }
`
export default SingleImgPicker
